// extracted by mini-css-extract-plugin
export default {"notification":"Gb21057","oldDeliveryDay":"G634c4b"};